import AWS from 'aws-sdk';
import { useFormik } from 'formik';
import html2canvas from 'html2canvas';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Placeholder, Sidebar } from './components';
import Banner from './components/Banner';
import Viewer, { useDimensions } from './components/Viewer';
import { calculatPrice } from './core/price';
import { useConfig } from './hooks/config';
import { Skeleton } from './layout';
import Alert from './layout/Alert';
import './styles/main.scss';

const S3_BUCKET = 'neon-static';
const REGION = 'us-east-1';

AWS.config.update({
  accessKeyId: 'AKIAZVVDPOKRNTAQYPNE',
  secretAccessKey: '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',
});

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

// const renderText = (
//   content: { children: { text: string; family?: string; color?: string }[] }[],
//   fonts: { name: string; family: string }[],
//   colors: { name: string; color: string }[],
//   alignment: 'L' | 'C' | 'R',
// ) => {
//   const canvas = document.createElement('canvas');
//   canvas.width = 400;
//   canvas.height = 400;
//   const ctx = canvas.getContext('2d');

//   if (!ctx) return '';
//   const { height, width } = canvas;
//   ctx.font = '48px serif';

//   const size = 48;
//   const lineOffset = 10;

//   const dimensions = content.map(({ children }) => {
//     const lineWidth = children.map(({ text, family }) => {
//       // TODO: styling
//       const modifier = fontFamilyModifiers[family || 'MoonTime.ttf'];
//       ctx.font = `${size * modifier}px ${fonts.find((font) => font.family === family)?.name}, ${
//         fonts[0]?.name
//       },sans-serif`;
//       // ctx.font = `${size}px ${family}, ${fonts[0]?.name},sans-serif`;
//       const dim = ctx.measureText(text.trim());
//       return { width: dim.width, height: dim.fontBoundingBoxAscent + dim.fontBoundingBoxDescent };
//     });
//     return lineWidth;
//   });
//   const maxWidth = Math.max(...dimensions.map((dims) => dims.reduce((sum, { width }) => sum + width, 0)));
//   const overallHeight =
//     dimensions.map((dim) => dim.flat(100)[0].height).reduce((sum, h) => sum + h, 0) +
//     Math.max(0, content.length - 1) * lineOffset;

//   content.forEach(({ children }, i) => {
//     const offset =
//       dimensions.slice(0, i).reduce((sum, e) => sum + e.flat(100)[0].height || 0, 0) + Math.max(0, i) * lineOffset;

//     children.forEach(({ text, family, color }, j) => {
//       const modifier = fontFamilyModifiers[family || 'MoonTime.ttf'];
//       ctx.font = `${size * modifier}px ${fonts.find((font) => font.family === family)?.name}, ${
//         fonts[0]?.name
//       },sans-serif`;
//       ctx.fillStyle = color || colors[0]?.color;
//       const _width = dimensions[i][j].width;
//       let horizontalOffset = 0;
//       if (alignment !== 'C') horizontalOffset = maxWidth - _width;
//       if (alignment === 'L') horizontalOffset *= -1;
//       ctx.fillText(
//         text,
//         width / 2 - _width / 2 + horizontalOffset,
//         height / 2 - overallHeight / 2 + offset + dimensions[i][j].height,
//       );
//     });
//   });

//   return canvas.toDataURL('image/png') || '';
// };

function App() {
  const isLoaded = useRef(false);
  const [textHasChanged, setTextHasChanged] = useState(false);
  const config = useConfig();
  const [type, setType] = useState('TEXT');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [lineHeight, setLineHeight] = useState(0);
  const [alignment, setAlignment] = useState<'C' | 'L' | 'R'>('C');

  const containerRef = useRef();
  const [value, setValue] = useState<{ type: string; children: any[] }[]>([
    {
      type: 'paragraph',
      children: [{ text: 'Your text' }],
    },
  ]);

  const formik = useFormik({
    initialValues: {
      family: config.options.families?.[0]?.name,
      color: 'pink',
      neon: 'THIN',
      use: 'INDOOR',
      size: 'MINI',
      support: 'SHAPE',
      remote: 'NO',
      proofing: 'NO',
      mounting: 'NO',
      background: 'DEFAULT',
      power: 'WALLPLUG',
    },
    onSubmit: async (values) => {
      let id = '';
      const viewer: HTMLElement | null = document.querySelector('#viewer');
      if (!viewer) return;
      setIsLoading(true);

      const meta = {
        Dimensions: `${Math.round(width)}cm/~${Math.round(height)}cm (w/h - The height is only an approximation.)`,
        'Neon type': values.neon.toLowerCase(),
        'Type of use': values.use.toLowerCase(),
        Support: config.options.supports.find((_) => _.value === values.support).title,
        'Remote & Dimmer': values.remote.toLowerCase(),
        'Power Supply': config.options.powerSupllies.find((_) => _.value === values.power).title,
        'Fast mounting kit': values.mounting.toLowerCase(),
        'Proofing service': values.proofing.toLowerCase(),
      };
      let title = {};

      if (!textHasChanged) {
        const res = await fetch('https://97yeow8u18.execute-api.eu-west-1.amazonaws.com/Prod/get-product', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            product: true,
            displaySize: [25, 40],
            size: values.size,
            value,
            meta: {
              Content: 'Dimmer & wall stickers',
            },
            config: values,
            banner: config.banner?.[0],
            preset: {
              sizes: config.options.sizes.reduce(
                (_, size) => ({
                  ..._,
                  [size.value]: {
                    price: size.price,
                    width: size.dimensions[0],
                    height: size.dimensions[1],
                  },
                }),
                {},
              ),

              banner: config.banner?.[0],
            },
          }),
        }).then((res) => res.json());

        id = res?.variants?.[0]?.id;
      } else if (config.isPredefined) {
        const res = await fetch('https://97yeow8u18.execute-api.eu-west-1.amazonaws.com/Prod/get-product', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            product: true,
            displaySize: [25, 40],
            size: values.size,
            value,
            meta,
            config: values,
            banner: config.banner?.[0],
            preset: {
              sizes: config.options.sizes.reduce(
                (_, size) => ({
                  ..._,
                  [size.value]: {
                    price: size.price,
                    width: size.dimensions[0],
                    height: size.dimensions[1],
                  },
                }),
                {},
              ),

              banner: config.banner?.[0],
            },
          }),
        }).then((res) => res.json());

        id = res?.variants?.[0]?.id;
      } else if (!!containerRef?.current) {
        const canvas = await html2canvas(viewer);
        const blobUrl: any = await new Promise((res) => canvas.toBlob(res));

        const colors = Array.from(
          new Set(
            value
              .map((v) => v.children.map((c) => c.color || config.options.colors[0].color))
              .flat(100)
              .map((c) => config.options.colors.find((col) => col.color === c)?.name)
              .filter(Boolean),
          ),
        ).join(', ');

        const fonts = Array.from(
          new Set(
            value
              .map((line) =>
                line.children.map((leaf: any) =>
                  'family' in leaf ? leaf?.family : config.options.families[0]?.family,
                ),
              )
              .flat(1000),
          ),
        )
          .map((f) => config.options.families.find((fam) => fam.family === f)?.name)
          .join(', ');

        // console.log(png, blobUrl);
        // const img = document.createElement('img');
        // img.src = png;
        // return document.body.appendChild(img);
        const key = await new Promise((res, rej) => {
          const key = `uploads/${Date.now()}`;
          const params = {
            ACL: 'public-read',
            Body: blobUrl,
            Bucket: S3_BUCKET,
            Key: key,
            ContentType: 'image/png',
          };
          myBucket
            .putObject(params)
            .on('complete', () => {
              res(key);
            })
            .send((err) => {
              rej(err);
            });
        });

        title = {
          Text: value.map((l) => l.children.map((c) => c.text).join('')).join('\n'),
          'Colours used': colors,
          'Font families': fonts,
        };

        const url = `https://neon-static.s3.amazonaws.com/${key}`;
        const res = await fetch('https://97yeow8u18.execute-api.eu-west-1.amazonaws.com/Prod/get-product', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            product: false,
            displaySize: [25, 40],
            size: values.size,
            value,
            config: values,
            banner: url,
            meta,
            title,
          }),
        }).then((res) => res.json());

        id = res?.variants?.[0]?.id;
      }
      setTimeout(() => {
        setIsLoading(false);
        setIsSuccess(true);
      }, 500);
      // @ts-ignore
      window?.analytics?.purchase('sign');
      window?.top?.postMessage(`finish-${id}-${JSON.stringify({ meta, title })}`, '*');
    },
  });

  useEffect(() => {
    if (isLoaded.current) setTextHasChanged(true);
    isLoaded.current = true;
  }, [JSON.stringify(value)]);

  const { width, height } = useDimensions(formik.values.size, value, lineHeight);

  useEffect(() => {
    formik.setFieldValue('family', config.options.families?.[0]?.name);
  }, [config.options.families?.[0]?.name]);

  const _handleSetLineHeight = (dir: number) => setLineHeight(Math.min(5, Math.max(-5, lineHeight + dir)));

  const price = useMemo(() => {
    const price = calculatPrice(formik.values.size, value, formik.values, config.priceResolver);
    // @ts-ignore
    window?.analytics?.configure('sign', { price, ...(formik.values as any) });
    return price;
  }, [JSON.stringify(value), JSON.stringify(formik.values)]);

  const _handleModalClose = () => setIsSuccess(false);

  let dimensions = config.options.sizes.find((_) => _.value === formik.values.size)?.dimensions;
  if (formik.values.size.includes('CUSTOM')) {
    const [width, height] = formik.values.size
      .split('_')[1]
      .split('x')
      .map((_) => parseInt(_));

    dimensions = [height, width];
  }

  useEffect(() => {
    const root = document.querySelector('#root');
    const sendHeight = () => {
      const root = document.querySelector('#root');
      const height = root?.scrollHeight;
      window.top?.postMessage(`height-${height}`, '*');
    };
    window.onmessage = function (e) {
      if (e.data === 'height') {
        sendHeight();
      }
    };

    const resizeObserver = new ResizeObserver((entries) => {
      sendHeight();
    });

    if (root) resizeObserver.observe(root);
  }, []);

  const textLength = value.map((_) => _.children.map((_) => _.text).join(' ')).join(' ').length;
  const label = !textHasChanged ? 'Checkout accessories' : null;

  // console.log(config.options.families);
  // useEffect(() => {
  //   const res: any = {};
  //   if (config.options.families?.length) {
  //     setTimeout(() => {
  //       const chars = `§'"+!%/=()ÖÜÓÚŐPOIUZTREWQASDFGHJKLÉÁŰ_:?MNBVCXYÍ0123456789öüóúőpoiuztrewqasdfghjkléáű-.,mnbvcxyí¬&™£$‹›{[]}\≠~¨ĻŅ^¨ź†¶€ę@ąß∂ń©ķ∆Ż•…^–;–Ķ~”„ć»«|•ŕŘ#$řŖŗ™}°īĪýÝł†Źś®šŁļ/* żŽŪ */—÷*ųŲ’‚©><Ŕ`;
  //       // const font = { family: 'Rather.ttf' };
  //       config.options.families.forEach((font) => {
  //         res[font.family] = {};
  //         const _chars = [...chars.split(''), '&nbsp;'];
  //         for (const char of _chars) {
  //           const p = document.createElement('p');
  //           document.querySelector('#root')?.prepend(p);
  //           p.dataset.family = font.family;
  //           console.log(font);
  //           p.style.fontFamily = font.family.split('.')[0];
  //           p.style.lineHeight = '1';
  //           p.style.fontSize = '100px';
  //           p.innerHTML = char;
  //           p.style.width = 'fit-content';
  //           const { width, height } = p.getBoundingClientRect();
  //           res[font.family][char] = { height, width, ratio: width / height };
  //         }
  //       });
  //       console.log('res', JSON.stringify(res));
  //     }, 5000);
  //     // p.remove();
  //   }
  // }, [config.options.families]);
  const disabled = formik.values.size === 'Custom';
  // console.log(formik.values.size);
  return (
    <>
      {isSuccess && (
        <Alert
          onClose={_handleModalClose}
          title='Thank you'
          actions={[
            { label: 'Go to cart', onClick: () => window?.top?.postMessage(`go-to-cart`, '*') },
            { label: 'Continue shopping' },
          ]}
          subtitle={
            <>
              Successfully added your{' '}
              <strong>
                <span>design</span>
              </strong>{' '}
              to your{' '}
              <strong>
                <span>shopping cart</span>
              </strong>
              .
            </>
          }
        />
      )}
      <Skeleton
        sidebar={
          <Sidebar
            isLoading={isLoading}
            onLineHeightChange={_handleSetLineHeight}
            price={disabled ? null : price}
            label={label}
            error={!textLength ? 'Please enter sign text' : disabled ? 'Please set a size' : error}
            formik={{ ...formik, values: { ...formik.values, lineHeight } }}
            value={value}
            onChange={setValue}
            {...{
              alignment: alignment as string,
              setAlignment: setAlignment as any as (val: string) => void,
              lineHeight,
              type,
              setType,
            }}
          />
        }
      >
        {config.banner ? (
          <Banner banner={String(config.banner)} />
        ) : type === 'TEXT' ? (
          <Viewer
            onError={setError}
            value={value}
            support={formik.values.support}
            background={formik.values.background}
            size={formik.values.size}
            weight={formik.values.neon}
            lineHeight={lineHeight}
            alignment={alignment}
            dimensions={dimensions}
            containerRef={containerRef}
          />
        ) : (
          <Placeholder />
        )}
      </Skeleton>
    </>
  );
}

export default App;
